import * as React from 'react';
import AccountService from '../../service/AccountService';
import { observer, inject } from 'mobx-react';
import {
  Dialog,
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  styled,
  Button,
} from '@mui/material';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import CloseIcon from '@mui/icons-material/Close';
import { RouterStore } from 'mobx-react-router';
import { getPlatformType } from '../../Config';

const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: '160px',
}));

export class UpgradeDialogState {
  @observable
  public open = false;
}

export type UpgradePlanDialogProps = {
  routing?: RouterStore;
  upgradeOpen: UpgradeDialogState;
  upgradeContent: string;
  account?: AccountService;
};

@inject('routing')
@inject('account')
@observer
export default class UpgradePlanDialog extends React.Component<UpgradePlanDialogProps> {
  @observable
  isUpgradeInMobile: boolean = false;

  @autobind
  handleClose() {
    this.props.upgradeOpen.open = false;
  }

  @autobind
  handleUpgradeClick() {
    var { routing } = this.props;
    routing.push(`/plan`);
    this.props.upgradeOpen.open = false;
  }

  render() {
    return (
      <React.Fragment>
        <Dialog
          open={this.props.upgradeOpen.open}
          onClose={this.handleClose}
          maxWidth='xs'
          fullWidth
          aria-labelledby='alert-dialog-title'
        >
          <DialogTitle
            id='alert-dialog-title'
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography style={{ flexGrow: 1 }}>Upgrade Plan</Typography>
            <IconButton aria-label='close' onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>{this.props.upgradeContent}</DialogContent>
          <DialogActions>
            <SubmitButton
              variant='contained'
              onClick={() =>
                getPlatformType() == 'BROWSER'
                  ? this.handleUpgradeClick()
                  : (this.isUpgradeInMobile = true)
              }
              color='primary'
              style={{ marginRight: 24 }}
            >
              <Typography>Upgrade Plan</Typography>
            </SubmitButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.isUpgradeInMobile}
          onClose={() => (this.isUpgradeInMobile = false)}
        >
          <DialogContent>
            <Typography style={{ flexGrow: 1 }}>
              Please go to our website at https://flowcharts.ai to upgrade.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant='contained'
              color='primary'
              onClick={() => (this.isUpgradeInMobile = false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
